export default [
  {
    name: 'grow_2792_user',
  },
  {
    name: 'grow_2792_create_custom_theme_enabled',
  },
  {
    name: 'grow_2792_single_user',
  },
  {
    name: 'grow_2792_forms_advantage_team',
  },
  {
    name: 'grow_2792_email_support',
  },
  {
    name: 'grow_2792_survey_create_limit',
  },
  {
    name: 'grow_2792_questions_per_form_survey',
  },
  {
    name: 'grow_2792_unlimited_questions',
  },
  {
    name: 'grow_2792_basic_question_types',
  },
  {
    name: 'grow_2792_forms_question_types',
  },
  {
    name: 'grow_2792_website_embed',
  },
  {
    name: 'grow_2792_zapier_integrations',
  },
  {
    name: 'grow_2792_file_upload',
  },
  {
    name: 'grow_2792_num_free_responses',
  },
  {
    name: 'grow_2792_basic_base_response_count',
  },
  {
    name: 'grow_2792_base_response_count',
  },
  {
    name: 'grow_2792_recurring_surveys',
  },
  {
    name: 'grow_2792_customer_success_manager',
  },
  {
    name: 'grow_2792_advanced_collaboration',
  },
  {
    name: 'grow_2792_database_response_view',
  },
  {
    name: 'grow_2792_dashboard',
  },
  {
    name: 'grow_2792_dashboard_pwd_protection',
  },
  {
    name: 'grow_2792_word_cloud_combine_hide',
  },
];
